import { render, staticRenderFns } from "./ModalSelectReceiver.vue?vue&type=template&id=6554640b&"
import script from "./ModalSelectReceiver.vue?vue&type=script&lang=js&"
export * from "./ModalSelectReceiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports